import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PuzzleCustom(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "PuzzleCustom", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44.727 8.72705V27.2305l-9.9732 4.4056-7.4813-4.4056v-7.0489h2.0778c1.1479 0 2.0779-.986 2.0779-2.2028 0-1.2159-.9293-2.2027-2.0779-2.2027h-2.0778V8.72705H44.727Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.2305 44.7275h-7.0487v-2.0779c0-1.1479-.986-2.0779-2.2027-2.0779-1.2161 0-2.2027.9308-2.2027 2.0779v2.0779H8.72754V27.2729h7.04866v2.0315c0 1.1652 1.0116 2.1461 2.2459 2.1244 1.1974-.0224 2.1595-.9433 2.1595-2.0779V27.273h7.0487l4.4063 7.4805-4.4061 9.974Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.8407 9.31831c1.1927 0 2.159.96639 2.159 2.15899 0 1.1918-.9656 2.1591-2.159 2.1591h-2.1591v6.0453h-6.0454v2.1108c0 1.2107-.9906 2.2298-2.2014 2.2074-1.1728-.0234-2.11673-.9802-2.11673-2.1591v-2.159H3.27246V3.27295H19.6815v6.04536h2.1592Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44.7273 27.1048v17.6225H27.1048V38.014H25.007c-1.1582 0-2.0979-.9398-2.0979-2.0979 0-1.1589.9398-2.0979 2.0979-2.0979h2.0978v-6.7133h6.7133V25.007c0-1.1583.9399-2.0979 2.0979-2.0979 1.1589 0 2.0979.9391 2.0979 2.0979v2.0979h6.7134v-.0001Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
PuzzleCustom.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PuzzleCustom"
};
validateTidalLicense();
export {
  PuzzleCustom
};
//# sourceMappingURL=PuzzleCustom.js.map
